module.exports = __webpack_public_path__ + "h5/img/board-header-people2.d6b8a6e0.png";